import z from 'zod';

export type CommonResponse<T> = {
  status: string;
  code: number;
  data: T;
};

export type ErrorResponse = {
  status: string;
  code: number;
  data: {
    message: string;
  };
};

export const serverPagination = z.object({
  total: z.number(),
  page: z.number(),
  size: z.number(),
  total_pages: z.number(),
});

export type ServerPagination = z.infer<typeof serverPagination>;

export const convertPagination = async (pagination: ServerPagination) => {
  const validated = await serverPagination.parseAsync(pagination);

  return {
    currentPage: validated.page,
    pageSize: validated.size,
    totalCount: validated.total,
    totalPages: validated.total_pages,
    hasNextPage: validated.page < validated.total_pages,
    hasPreviousPage: validated.page > 1,
  };
};

export type Pagination = {
  currentPage: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};

export type ResponseWithOriginPagination<T> = {
  data: T[];
  pagination: ServerPagination;
};

export type ResponseWithPagination<T> = {
  data: T[];
  pagination: Pagination;
};
